namespace AgerLMS.CMS {
    export interface GetMeDistanceSalesAgreementRequest extends Serenity.ServiceRequest {
        UserAdressId?: number;
    }
}
